import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';

export function useClassroomNiveaux(classroomIds?: string[]): string[] {
  const classrooms = useClassrooms();

  if (!classroomIds || classroomIds.length === 0) {
    return [];
  }

  const selectedClassrooms = classrooms.filter(c =>
    classroomIds.includes(c.id),
  );

  return selectedClassrooms.map(c => c.degree).filter(Boolean) as string[];
}
